/* RESPONSIBLE TEAM: team-ai-insights */
import Performance from 'embercom/routes/apps/app/automation/fin-ai-agent/analyze/performance';

export default class FinStandalonePerformance extends Performance {
  analytics = {
    section: 'standalone',
    place: 'performance',
  };

  templateName = 'apps/app/automation/fin-ai-agent/analyze/performance';
  routeWhenNotOptedIn = 'apps.app.standalone.setup';
}
